<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-button
      class="mb-4"
      variant="primary"
      size="xl"
      v-auth="`update`"
      @click="save()"
    >
      保存
    </b-button>

    <div class="setup-container">
      <b-card
        border-variant="primary"
        header="A組(永保)"
        header-border-variant="primary"
        header-bg-variant="primary"
        header-text-variant="white"
        align="left"
      >
        <div class="setup-area">
          <div class="setup-items" v-for="(item, index) of formA" :key="index">
            <div class="title">{{ item.title }}</div>

            <b-form-input
              v-model.number="item.value"
              @change="changeANumberDeaths(item)"
              :disabled="item.isEdit"
            ></b-form-input>
          </div>
        </div>
      </b-card>

      <b-card
        border-variant="success"
        header="B組(長安)"
        header-border-variant="success"
        header-bg-variant="success"
        header-text-variant="white"
        align="left"
      >
        <div class="setup-area">
          <div class="setup-items" v-for="(item, index) of formB" :key="index">
            <div class="title">{{ item.title }}</div>

            <b-form-input
              v-model.number="item.value"
              @change="changeBNumberDeaths(item)"
              :disabled="item.isEdit"
            ></b-form-input>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import reportApi from "@/models/API/reportApi";
import BreadCrumb from '@/components/layouts/BreadCrumb';
import configApi from "@/models/API/configApi";

export default {
  name: 'frontendDataSetup',
  components: {
    BreadCrumb,
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '設定', url: '', isActive: true },
          { name: '前台數據設定', url: '', isActive: false }
        ]
      },
      formA: [
        {
          id: 2,
          title: '當月新增人數',
          value: 0,
          isEdit: false
        },
        {
          id: 3,
          title: '當月互助人數',
          value: 0,
          isEdit: true
        },
        {
          id: 4,
          title: '當月辭世人數',
          value: 0,
          isEdit: false
        }
      ],
      formB: [
        {
          id: 5,
          title: '當月新增人數',
          value: 0,
          isEdit: false
        },
        {
          id: 6,
          title: '當月互助人數',
          value: 0,
          isEdit: true
        },
        {
          id: 7,
          title: '當月辭世人數',
          value: 0,
          isEdit: false
        },
      ]
    }
  },
  mounted() {
    this.configApi = new configApi();
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.getFrontendDataSetup();
      this.getReportMonthStatistical();
    },
    // 查詢前台數據設定
    getFrontendDataSetup() {
      this.configApi.getConfig((response) => {
        const res = response.data;

        this.formA = this.formA.map(form_item => {
          const matching_data = res.data.find(item => item.id === form_item.id && !form_item.isEdit);
          const updated_value = matching_data ? matching_data.value : form_item.value;

          return {
            ...form_item,
            value: updated_value
          }
        });

        this.formB = this.formB.map(form_item => {
          const matching_data = res.data.find(item => item.id === form_item.id && !form_item.isEdit);
          const updated_value = matching_data ? matching_data.value : form_item.value;

          return {
            ...form_item,
            value: updated_value
          }
        });
      })
    },
    // 取得每月統計
    getReportMonthStatistical(params) {
      this.reportApi.getReportMonthStatistical((response) => {
        const res = response.data;

        res.data.forEach(item => {
          if (item.id === 3) {
            const find_index = this.formA.findIndex(item => item.id === 3);

            this.formA[find_index].value = item.value;
          } else if (item.id === 6) {
            const find_index = this.formB.findIndex(item => item.id === 6);

            this.formB[find_index].value = item.value;
          }
        })
      }, params)
    },
    // 更新前台數據設定
    save() {
      const params = {
        'details': JSON.stringify([...this.formA, ...this.formB])
      };

      this.configApi.updateMultiConfig((response) => {
        const res = response.data;

        if (res.code === 0) {
          this.getFrontendDataSetup();

          const result = { message: `更新成功`, title: '前台數據設定' };

          this.configApi.toast(() => {}, result, true);
        }
      }, params)
    },
    // 改變A組身故件數
    changeANumberDeaths(data) {
      if (data.id !== 4) return;

      this.formA.forEach(item => {
        if (item.id === 3) {
          item.value = Math.ceil(data.value / 12 *1000);
        }
      });
    },
    // 改變B組身故件數
    changeBNumberDeaths(data) {
      if (data.id !== 7) return;

      this.formB.forEach(item => {
        if (item.id === 6) {
          item.value = Math.ceil(data.value / 12 *1000);
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.setup-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  .card  {
    flex-basis: calc(50% - 20px);
    .card-body {
      .setup-area {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        .setup-items {
          flex-basis: calc(50% - 20px);
          display: flex;
          align-items: center;
          column-gap: 10px;
          .title {
            white-space: nowrap;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .setup-container {
    .card  {
      flex: auto;
      .card-body {
        .setup-area {
          .setup-items {
            flex-grow: 1;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/frontendDataSetup.vue